// src/app/provider/events.service.ts
import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class Events {
    private channels: { [key: string]: Subject<any>; } = {};

    public subscribe = (topic: string, observer: (_: any) => void): Subscription => {
        if (!this.channels[topic]) {
            this.channels[topic] = new Subject<any>();
        }
        return this.channels[topic].subscribe(observer);
    }

    public publish = (topic: string, data: any): void => {
        const subject = this.channels[topic];
        if (!subject) {
            // It's generally fine to return here if no one is listening.
            // If you wanted to create a new subject for future subscribers upon publish,
            // you could add: this.channels[topic] = new Subject<any>();
            return;
        }
        subject.next(data);
    }

    public destroy = (topic: string): void => {
        const subject = this.channels[topic];
        if (!subject) {
            return;
        }
        subject.complete(); // Completes the subject, preventing new emissions
        delete this.channels[topic]; // Removes it from the channels map
    }
}